import { render, staticRenderFns } from "./PercentCellBalance.vue?vue&type=template&id=61cbd974"
import script from "./PercentCellBalance.vue?vue&type=script&lang=js"
export * from "./PercentCellBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports